import { Paper } from "@mui/material";
import React from "react";
import Footer from "../Shared/Footer";

const Layout = ({ component }) => {
  return (
    <Paper style={{ borderRadius: 0 }} elevation={0} className="">
      <div className="overflow-x-hidden h-full">{component}</div>
      <div className="">
        {window.location.pathname.slice(1, 8) !== "product" && <Footer />}
      </div>
    </Paper>
  );
};

export default Layout;
